<template>
  <div :style="style">
    {{ $tc(text) }}
  </div>
</template>

<script>
export default {
    name: 'BackendTranslatedEntityPlainText',
    props: {
        value: { type: [Number, String], required: true },
        values: { type: Array, required: true },
        invalid: { type: Object, required: true }
    },
    computed: {
        style() {
            if (!this.selectedValue && !this.selectAll) {
                return { 'background-color': this.invalid.bgColor, color: this.invalid.color }
            }
            return {}
        },
        text() {
            if (this.selectAll) {
                return this.value
            }
            if (this.selectedValue) {
                return this.selectedValue.name ?? this.selectedValue.label
            }
            return this.invalid.label
        },
        selectedValue() {
            return this.values.find(value =>
                value.id === this.value ||
                value.id === `${this.value}`)
        },
        selectAll() {
            return this.value === this.$tc('component.agGrid.selectAll')
        }
    }
}
</script>

<style scoped lang="scss">
.sr-incident-badge {
  width: 85px;
}
</style>
